module.exports = __webpack_public_path__ + "static/img/process-3.124d8413.png";